import { render, staticRenderFns } from "./IntranetRecruitmentRequestPage.vue?vue&type=template&id=12bd0348&"
import script from "./IntranetRecruitmentRequestPage.vue?vue&type=script&lang=js&"
export * from "./IntranetRecruitmentRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports